import {lazy} from '@aboutyou/lazy-imports';
import React, {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useReducer,
} from 'react';

const LegacyStateSyncContext = createContext(false);
const ActivateLegacyStateSyncContext = createContext(() => {});

export const LegacyStateProvider: FC<PropsWithChildren> = ({children}) => {
  const [anyLegacyComponentActive, activate] = useReducer(() => true, false);
  return (
    <LegacyStateSyncContext.Provider value={anyLegacyComponentActive}>
      <ActivateLegacyStateSyncContext.Provider value={activate}>
        {children}
      </ActivateLegacyStateSyncContext.Provider>
    </LegacyStateSyncContext.Provider>
  );
};

export const useActivateLegacySync = () => {
  const activate = useContext(ActivateLegacyStateSyncContext);
  useEffect(() => {
    activate();
  }, []);
};

const SyncLegacyStateWithLegacy = lazy(() =>
  import('./SyncLegacyState').then(mod => ({
    default: mod.SyncLegacyStateWithLegacy,
  })),
);

export const ConditionalSyncLegacyState: React.FC<{
  children: (options: {mountLegacyComponents: boolean}) => React.ReactNode;
}> = ({children}) => {
  const isAnyLegacyComponentActive = useContext(LegacyStateSyncContext);

  return isAnyLegacyComponentActive ? (
    <>
      <SyncLegacyStateWithLegacy />

      {typeof children === 'function'
        ? children({
            mountLegacyComponents: isAnyLegacyComponentActive,
          })
        : children}
    </>
  ) : null;
};
